import React from 'react';
import PropTypes from 'prop-types';

export default function MoreHorizontal(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.width} height={props.width} stroke={props.color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
  );
}

MoreHorizontal.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

MoreHorizontal.defaultProps = {
  color: '#202020',
  width: 24,
};